// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"273":"33af861f","868":"2336560f"}[chunkId] + ".css";
};